/* p78 · koleksiyon sayfası: Horizon sonsuz kaydırmasını "Daha fazla göster" düğmesine bağlar.
   Horizon (paginated-list.js) bir sonraki sayfayı [ref="viewMoreNext"] görünür olunca ekler; bu betik o
   tetikleyiciyi CSS ile gizler ve yalnız düğmeye basınca kısa süre görünür yapar. İlerleme: "16 / 24 ürün".
   Betik yüklenmezse Horizon'un otomatik yüklemesi aynen çalışır. */

const header = document.querySelector('[data-cd-collection-header]');
const results = document.querySelector('results-list');

if (
  header instanceof HTMLElement &&
  header.dataset.loadMore === 'true' &&
  results instanceof HTMLElement &&
  results.getAttribute('infinite-scroll') === 'true' &&
  !results.classList.contains('cd-load-more-on')
) {
  const label = header.dataset.loadMoreLabel || '';
  const progress = header.dataset.loadMoreProgress || '';
  let armTimer = 0;
  let frame = 0;
  let lastShown = -1;

  results.classList.add('cd-load-more-on');

  const total = () => {
    const form = document.querySelector('facets-form-component[data-results-count], [data-results-count]');
    const fromFacets = Number(form?.getAttribute('data-results-count'));
    return Number.isFinite(fromFacets) && fromFacets > 0 ? fromFacets : Number(header.dataset.total) || 0;
  };

  const disarm = () => {
    clearTimeout(armTimer);
    results.classList.remove('cd-load-more-armed');
    results.querySelector('.cd-load-more__button')?.removeAttribute('aria-busy');
  };

  const build = () => {
    const wrap = document.createElement('div');
    wrap.className = 'cd-load-more';
    wrap.innerHTML =
      '<p class="cd-load-more__text" role="status"></p>' +
      '<div class="cd-load-more__bar" aria-hidden="true"><span></span></div>' +
      '<button type="button" class="cd-load-more__button button button-secondary"></button>';
    wrap.querySelector('button')?.addEventListener('click', () => {
      const button = wrap.querySelector('button');
      button?.setAttribute('aria-busy', 'true');
      results.classList.add('cd-load-more-armed');
      clearTimeout(armTimer);
      armTimer = window.setTimeout(disarm, 5000);
    });
    return wrap;
  };

  const update = () => {
    /* Horizon filtre sonrası results-list'i sunucu HTML'iyle eşler (morph) ve sınıfı siler; düğme modu korunur */
    if (!results.classList.contains('cd-load-more-on')) results.classList.add('cd-load-more-on');
    const grid = results.querySelector('[ref="grid"]');
    const trigger = results.querySelector('[ref="viewMoreNext"]');
    let wrap = results.querySelector('.cd-load-more');

    if (!grid || !trigger) {
      wrap?.remove();
      return;
    }
    if (!wrap) {
      wrap = build();
      trigger.after(wrap);
    }

    const cards = grid.querySelectorAll(':scope > [ref="cards[]"]');
    const shown = cards.length;
    if (shown !== lastShown) {
      lastShown = shown;
      disarm();
    }
    const all = Math.max(total(), shown);
    const lastPage = Number(grid.getAttribute('data-last-page')) || 1;
    let maxPage = 1;
    for (const card of cards) maxPage = Math.max(maxPage, Number(card.getAttribute('data-page')) || 1);

    const done = shown >= all || maxPage >= lastPage;
    const hideWrap = all <= shown && maxPage <= 1;
    if (wrap.hidden !== hideWrap) wrap.hidden = hideWrap;

    /* Yalnız değişince yaz: aksi hâlde kendi değişikliğimiz gözlemciyi yeniden tetikler */
    const setText = (node, value) => {
      if (node && node.textContent !== value) node.textContent = value;
    };
    setText(wrap.querySelector('.cd-load-more__text'), progress.replaceAll('[gosterilen]', String(shown)).replaceAll('[toplam]', String(all)));
    const bar = wrap.querySelector('.cd-load-more__bar');
    if (bar instanceof HTMLElement) bar.style.setProperty('--cd-lm-pct', `${all ? Math.min(100, (shown / all) * 100) : 100}%`);
    const button = wrap.querySelector('button');
    if (button) {
      if (button.hidden !== done) button.hidden = done;
      setText(button, label.replaceAll('[kalan]', String(Math.max(0, all - shown))));
    }
  };

  /* Yeni kartlar gelince ya da filtre bölümü yeniden çizince */
  new MutationObserver(() => {
    if (frame) return;
    frame = window.setTimeout(() => {
      frame = 0;
      update();
    }, 0);
  }).observe(results, { childList: true, subtree: true });

  update();
}

/* Mobil alt çubuk (cd-collection-header): Filtrele → Horizon filtre çekmecesi; Sırala → sort_by ile sayfayı yeniden yükler
   (mevcut filtreler URL'de korunur); etkin filtre sayısı Horizon'un kabarcığından okunur (filtreler AJAX ile değişir). */
const mbar = document.querySelector('[data-cd-mbar]');
if (mbar instanceof HTMLElement && !mbar.dataset.cdReady) {
  mbar.dataset.cdReady = 'true';

  mbar.querySelector('[data-cd-mbar-filter]')?.addEventListener('click', () => {
    const toggle = document.querySelector('.facets-toggle__button');
    if (toggle instanceof HTMLElement) toggle.click();
  });

  mbar.querySelector('[data-cd-mbar-sort]')?.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  const count = mbar.querySelector('[data-cd-mbar-count]');
  const syncCount = () => {
    if (!(count instanceof HTMLElement)) return;
    const bubble = document.querySelector('.facets-toggle__button .filter-count-bubble__text');
    const value = bubble?.textContent?.trim() || '';
    const hide = !value || value === '0';
    if (count.textContent !== value) count.textContent = value;
    if (count.hidden !== hide) count.hidden = hide;
  };
  const grid = document.querySelector('results-list') || document.body;
  let countFrame = 0;
  new MutationObserver(() => {
    if (countFrame) return;
    countFrame = window.setTimeout(() => {
      countFrame = 0;
      syncCount();
    }, 0);
  }).observe(grid, { childList: true, subtree: true });
  syncCount();
}
